import { Tag } from 'antd'
import { useTranslation } from 'next-i18next'
import userApi from 'src/api/userApi'
import useGetWithContext from 'src/hooks/useGetWithContext'

export function TagStudentType({ studentId }) {
  const { t } = useTranslation()
  const { data } = useGetWithContext(
    `GET_STUDENTS_${studentId}`,
    userApi.detailStudent,
    studentId,
    { isDisabled: !studentId },
  )
  
  return (
    data?.tagStudentTypes.length ? (
      data?.tagStudentTypes.map(tag => {
        if(!['ON_GOING', 'EXPIRED'].includes(tag)) {
          return (
            <Tag className='rounded mr-2' color={color[tag]}>
              {t(`constant.tag_student_type.${tag}`)}
            </Tag>
          )
        }
      })
    ) : <></>
  )
}

const color = {
  NEW: '#87d068',
  ON_GOING: 'blue',
  RENEWAL_COMING_SOON: 'magenta',
  EXPIRED: 'default'
}
